module.exports = __webpack_public_path__ + "static/media/topmenu.7f6e4eb4.svg";